import React from 'react';
import { Alert, Typography } from '@mui/material';

export interface FactorsDisplayProps {
    positiveFactors?: string[];
    riskFactors?: string[];
}

/**
 * Component to display positive and risk factors in Alert components
 * Used in both SingleEventAnalysisTab and SeatFactorModal
 */
const FactorsDisplay: React.FC<FactorsDisplayProps> = ({ positiveFactors = [], riskFactors = [] }) => {
    return (
        <>
            {/* Positive Factors */}
            {positiveFactors.length > 0 && (
                <Alert severity="success" sx={{ mt: 2 }}>
                    <Typography variant="subtitle2">Positive Factors:</Typography>
                    {positiveFactors.map((factor, idx) => (
                        <Typography key={idx} variant="body2">• {factor}</Typography>
                    ))}
                </Alert>
            )}

            {/* Risk Factors */}
            {riskFactors.length > 0 && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                    <Typography variant="subtitle2">Risk Factors:</Typography>
                    {riskFactors.map((factor, idx) => (
                        <Typography key={idx} variant="body2">• {factor}</Typography>
                    ))}
                </Alert>
            )}
        </>
    );
};

export default FactorsDisplay;
